import SiteType from "types/SiteType";
import IXConfig from "./IXConfig";

export function getScriptUrl(site: SiteType): string {
    return (IXConfig[site] || IXConfig[SiteType.BUSINESS]).scriptUrl;
}
